import {
  RESOURCE_TYPE_DATA_SET,
  RESOURCE_TYPE_SINK,
  RESOURCE_TYPE_CREDENTIALS,
  RESOURCE_TYPE_SOURCE,
} from 'js/constants/resourceTypes';

import flowTypes from 'new/components/flows/types/flowTypes';
import { createContext } from 'react';

export type Action = {
  type: 'create' | 'edit';
  resource:
    | typeof RESOURCE_TYPE_SOURCE
    | typeof RESOURCE_TYPE_DATA_SET
    | typeof RESOURCE_TYPE_SINK
    | typeof RESOURCE_TYPE_CREDENTIALS;
  id?: number;
  nexsetId?: number;
  queryParams?: Record<string, string>;
  flowType?: keyof typeof flowTypes;
  parentDataSetId?: number;
  onComplete?: (data: any) => void;
};

export type ContextType = {
  setAction: (action: Action) => void;
  queryParams?: Record<string, string>;
};

export const ResourceEditContext = createContext<ContextType>(null);
